// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid","root":"grid-m__root__3e-Fb","header":"grid-m__header__Xgbwh","filterGroup":"grid-m__filterGroup__lccgY"};